package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val id: Int,
    val username: String,
    val role: String,
    val totpEnabled: Boolean,
)

@Serializable
data class RegisterRequestDto(
    val username: String,
    val password: String,
)

@Serializable
data class UsernameLoginRequestDto(
    val username: String,
    val password: String,
)

@Serializable
data class UsernameLoginResponseDto(
    val id: Int,
    val username: String,
    val role: String,
    val totpEnabled: Boolean,
    val isAdmin: Boolean,
)

@Serializable
data class TotpVerifyRequestDto(
    val code: String,
    val secret: String? = null,
)

@Serializable
data class TotpVerifyResponseDto(
    val verified: Boolean,
    val totpEnabled: Boolean,
)

@Serializable
data class TotpSetupResponseDto(
    val secret: String,
    val qrCodeUrl: String,
)

@Serializable
data class UpdateUsernameRequestDto(
    val newUsername: String,
)

@Serializable
data class UsernameAvailableResponseDto(
    val available: Boolean,
    val reason: String? = null,
)
